import ResolvePageComponent from './ResolvePageComponent';

export type { ResolvePageComponentProps } from './ResolvePageComponent';
export default ResolvePageComponent;
